export default __webpack_public_path__ + "static/opencv-fc1be3ca523fe4896101181ba37fcc3e.png";